import y from"react";import{useAuth as q}from"@fourthwall/auth";import{getCurrentEnvironment as D}from"@fourthwall/env";import{useLocation as K}from"react-router-dom";import{StringParam as W,useQueryParam as F}from"use-query-params";import{createQueryHook as j}from"@fourthwall/utils/dist/queries";import{UserApiClient as E}from"@fourthwall/services/dist/UserApiClient";var h=j(E.getUserConnections,{queryKey:["userConnections"]});import{isProduction as J}from"@fourthwall/utils";var O=()=>{let o=J()?"https://fourthwall.com/preonboarding/":"https://staging.fourthwall.com/preonboarding/",e=new URL(o);new URL(window.location.href).searchParams.forEach((t,i)=>{i!=="redirect"&&e.searchParams.set(i,t)}),e.searchParams.has("pathname")||e.searchParams.set("pathname",window.location.pathname),window.location.href=e.toString()},b=()=>{var w;let[o]=F("redirect",W),e=typeof o=="string",{logout:n}=q(),t=K(),{userConnectionsQuery:i}=h(void 0,{staleTime:1/0,retry:!1});if(i.isLoading)return{sitesManagerGuard:{state:"loading"}};if(!e)return{sitesManagerGuard:{state:"children"}};if(i.isError)return{sitesManagerGuard:{state:"children"}};let N=(()=>{var a;return((a=i.data.agencies)==null?void 0:a.map(s=>({id:s.id,title:s.name,badge:"Partner",logo:s.logoUri,url:D()==="production"?"https://partners.fourthwall.com/":"https://partners.staging.fourthwall.com/"})))||[]})(),A=((w=i.data.shops)==null?void 0:w.map(a=>{let s=new URL(a.internalBaseUri);return s.pathname=t.pathname,s.search=t.search,s.searchParams.delete("redirect"),{id:a.id,title:a.name,logo:a.logoUri,logoBackground:`${a.internalBaseUri}/platform/theme/background.png`,url:s.toString()}}))||[],d=[...N,...A];return i.isSuccess&&d.length===0&&O(),d.length===1?(d[0].url&&window.location.assign(d[0].url),{sitesManagerGuard:{state:"loading"}}):{sitesManagerGuard:{state:"manager",items:d,onLogout:n}}};import u from"react";import{DashboardLogo as ae}from"@fourthwall/components/dist/common/DashboardLogo";import{Heading as se}from"@fourthwall/components/dist/common/Heading";import{useMediaQueryContext as pe}from"@fourthwall/components/dist/providers/MediaQueryProvider";import{LogoutIcon as le}from"@fourthwall/icons";import p from"react";import{mediaQueries as m}from"@fourthwall/components/dist/providers/MediaQueryProvider";import g from"styled-components";var C=g.header`
  height: 64px;
  padding: 0 var(--space-500);

  display: flex;
  align-items: center;
  justify-content: space-between;

  ${m.tablet} {
    height: 80px;
    padding: 0 var(--space-800);
  }

  ${m.laptop} {
    position: fixed;
    left: 0;
    top: 0;
    right: 0;
  }
`,M=g.main`
  min-height: calc(100svh - 64px);
  padding: 0 var(--space-500);

  display: flex;
  align-items: center;
  justify-content: center;

  ${m.tablet} {
    min-height: calc(100svh - 80px);
    padding: 0 var(--space-800);
  }

  ${m.laptop} {
    min-height: 100svh;
  }
`,L=g.div`
  flex: 1;
  margin: var(--space-1600) 0;
`,P=g.div`
  margin-bottom: var(--space-400);

  text-align: center;

  ${m.tablet} {
    margin-bottom: var(--space-600);
  }
`,I=g.div`
  max-width: 588px;
  margin: 0 auto;
`;var G=({logo:o,link:e,heading:n,children:t})=>p.createElement("div",null,p.createElement(C,null,p.createElement("div",null,o),p.createElement("div",null,e)),p.createElement(M,null,p.createElement(L,null,p.createElement(P,null,n),p.createElement(I,null,t))));import S from"react";import{Icon as _}from"@fourthwall/components/dist/common/Icon";import{ButtonClean as R}from"@fourthwall/components/dist/common/ButtonClean";import Y from"styled-components";var U=Y.div`
  display: grid;
  grid-template-columns: auto auto;
  gap: var(--space-250);
  align-items: center;
`;var k=({icon:o,...e})=>S.createElement(R,{...e,label:S.createElement(U,null,S.createElement(_,{component:o,height:16}),e.label),withUnderline:!1});import r from"react";import{useMediaQueryContext as te}from"@fourthwall/components/dist/providers/MediaQueryProvider";import{LogoImage as re}from"@fourthwall/components/dist/common/LogoImage";import{Tag as oe}from"@fourthwall/components/dist/common/Tag";import{Icon as ne}from"@fourthwall/components/dist/common/Icon";import{ArrowShortRightIcon as ie}from"@fourthwall/icons";import{mediaQueries as c}from"@fourthwall/components/dist/providers/MediaQueryProvider";import l from"styled-components";var x=l.a`
  width: 100%; // when as 'button'
  padding: var(--space-300) var(--space-500);
  border: 1px solid var(--border-tertiary);

  display: grid;
  grid-template-columns: auto 1fr auto;
  align-items: center;
  gap: var(--space-400);

  &:hover {
    background: var(--bg-secondary);
  }

  ${c.tablet} {
    padding: var(--space-200);
    padding-right: var(--space-600);

    gap: var(--space-500);
  }
`,B=l.li`
  & + & {
    ${x} {
      margin-top: -1px;
    }
  }
`,f=l.div`
  min-width: 0;
`,T=l.div`
  color: var(--text-primary);
  font-size: var(--font-size-300);
  font-weight: var(--font-weight-semibold);

  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  display: flex;
  gap: var(--space-150);
  align-items: center;

  > div {
    min-width: 0;
  }

  ${c.tablet} {
    font-size: var(--font-size-400);

    gap: var(--space-200);
  }
`,$=l.div`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`,z=l.div`
  flex: 0 0 70px;
  display: flex;
  justify-content: flex-end;

  ${c.tablet} {
    flex-basis: 80px;
  }
`,Q=l.div`
  color: var(--text-secondary);
  font-size: var(--font-size-300);
  font-weight: var(--font-weight-regular);

  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  ${c.tablet} {
    font-size: var(--font-size-400);
  }
`,H=l.div`
  color: var(--icon-secondary);
`;var v=({items:o,onItemClick:e})=>{let{tablet:n}=te();return r.createElement("ul",null,o.map(t=>r.createElement(B,{key:t.title,onClick:()=>e==null?void 0:e(t)},r.createElement(x,{as:t.url?"a":"button",href:t.url},r.createElement(f,null,r.createElement(re,{logo:t.logo,logoBackground:t.logoBackground,placeholder:t.title.charAt(0),placeholderVariant:"color",size:n?"big":"extraSmall"})),r.createElement(f,null,r.createElement(T,null,r.createElement($,null,t.title),t.badge&&r.createElement(z,null,r.createElement(oe,{label:t.badge,appearance:"default",size:"small",display:"inline-flex"}))),t.subtitle&&r.createElement(Q,null,t.subtitle)),r.createElement(f,null,r.createElement(H,null,r.createElement(ne,{component:ie,height:16})))))))};var V=({items:o,onLogout:e})=>{let{tablet:n}=pe();return u.createElement(G,{logo:u.createElement(ae,null),link:u.createElement(k,{icon:le,label:"Logout",onClick:e}),heading:u.createElement(se,{type:n?"h3":"h4",weight:"bold"},"What do you want to manage?")},u.createElement(v,{items:o}))};var de=({children:o})=>{let{sitesManagerGuard:e}=b();return e.state==="loading"?null:e.state==="children"?y.createElement(y.Fragment,null,o):y.createElement(V,{...e})};export{v as SiteList,de as SitesManagerGuardContainer,h as useUserConnectionsQuery};
//# sourceMappingURL=index.js.map